import { AlvaraSummary } from "./types";

const MOCK_ALVARAS: AlvaraSummary[] = [
  {
    id: "1",
    protocolo: "ALV-2024-000123",
    tipo: "emissao",
    status: "emitido",
    endereco: "Rua Principal, 100 - Centro, Aracati-CE",
    dataCriacao: "2024-01-15",
    dataEmissao: "2024-01-20",
    requerente: "João Silva",
  },
  {
    id: "2",
    protocolo: "ALV-2024-000456",
    tipo: "emissao",
    status: "em_analise",
    endereco: "Av. Beira Mar, 500 - Praia, Aracati-CE",
    dataCriacao: "2024-03-10",
    requerente: "Maria Santos",
  },
  {
    id: "3",
    protocolo: "ALV-2024-000789",
    tipo: "renovacao",
    status: "aguardando_pagamento",
    endereco: "Rua das Flores, 250 - Jardim, Aracati-CE",
    dataCriacao: "2024-05-22",
    requerente: "Pedro Oliveira",
  },
  {
    id: "4",
    protocolo: "ALV-2024-001012",
    tipo: "emissao",
    status: "aguardando_confirmacao",
    endereco: "Trav. São José, 80 - Centro, Aracati-CE",
    dataCriacao: "2024-06-01",
    requerente: "Ana Costa",
  },
  {
    id: "5",
    protocolo: "ALV-2024-001345",
    tipo: "emissao",
    status: "cancelado",
    endereco: "Rua Nova, 310 - Vila Nova, Aracati-CE",
    dataCriacao: "2024-02-18",
    requerente: "Carlos Mendes",
  },
];

export function getAlvaras(): AlvaraSummary[] {
  return MOCK_ALVARAS;
}

export function getStatusLabel(status: AlvaraSummary["status"]) {
  const labels: Record<string, { label: string; color: string }> = {
    rascunho: { label: "Rascunho", color: "bg-gray-100 text-gray-600" },
    aguardando_confirmacao: {
      label: "Aguardando Confirmação",
      color: "bg-amber-100 text-amber-700",
    },
    aguardando_pagamento: {
      label: "Aguardando Pagamento",
      color: "bg-orange-100 text-orange-700",
    },
    emitido: { label: "Emitido", color: "bg-green-100 text-green-700" },
    cancelado: { label: "Cancelado", color: "bg-red-100 text-red-700" },
    em_analise: { label: "Em Análise", color: "bg-blue-100 text-blue-700" },
  };
  return labels[status] || { label: status, color: "bg-gray-100 text-gray-600" };
}

export function generateProtocolo() {
  const year = new Date().getFullYear();
  const num = String(Math.floor(Math.random() * 999999)).padStart(6, "0");
  return `ALV-${year}-${num}`;
}
